import { Skeleton } from '@/components/ui/skeleton';
import type { LearnedRecipeSummary } from '../hooks/useLearnedRecipes';

interface LearnedRecipesTableProps {
  learnedRecipes: LearnedRecipeSummary[];
  loading: boolean;
}

export function LearnedRecipesTable({ learnedRecipes, loading }: LearnedRecipesTableProps) {
  if (loading) {
    return (
      <div className="space-y-2">
        {Array.from({ length: 5 }).map((_, i) => (
          <Skeleton key={i} className="h-10 w-full" />
        ))}
      </div>
    );
  }

  if (learnedRecipes.length === 0) {
    return <p className="text-center text-muted-foreground py-8">No learned recipes found.</p>;
  }

  return (
    <div className="border rounded-lg overflow-hidden">
      <table className="w-full text-sm">
        <thead className="bg-muted/50">
          <tr>
            <th className="text-left px-4 py-2 font-medium">Learned ID</th>
            <th className="text-left px-4 py-2 font-medium">User ID</th>
            <th className="text-left px-4 py-2 font-medium">Recipe ID</th>
            <th className="text-left px-4 py-2 font-medium">Learned At</th>
          </tr>
        </thead>
        <tbody className="divide-y">
          {learnedRecipes.map((lr) => (
            <tr key={lr.learnedId} className="hover:bg-muted/30">
              <td className="px-4 py-2 font-mono text-xs">{lr.learnedId}</td>
              <td className="px-4 py-2 font-mono text-xs">{lr.userId}</td>
              <td className="px-4 py-2 font-mono text-xs">{lr.recipeId}</td>
              <td className="px-4 py-2">{new Date(lr.learnedAt).toLocaleDateString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
